<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M50.78 29.48l-6.23-23A2 2 0 0042.62 5H21.39a2 2 0 00-1.93 1.48l-6.24 23A2 2 0 0015.15 32H30.5v19h-3a6.51 6.51 0 00-6.5 6.5V59h22v-1.5a6.51 6.51 0 00-6.5-6.5h-3V32H41v4.16a3.49 3.49 0 102 0V32h5.84a2 2 0 001.94-2.52zM39.67 56H24.34a3.51 3.51 0 013.17-2h9a3.53 3.53 0 013.16 2zm3.83-16.5A1.5 1.5 0 1142 38a1.5 1.5 0 011.5 1.5zM16.46 29l5.69-21h19.71l5.68 21z"/></svg>